import React from "react";
import { Link } from "react-router-dom";
import { Award, Eye, Calendar } from "lucide-react";
import AppLayout from "../components/AppLayout";
import { certificates } from "../data/mockData";

export default function Certificates() {
    return (
        <AppLayout searchPlaceholder="Search certificates...">
            <div className="mb-10">
                <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight">Certificates</h1>
                <p className="text-sm text-gray-400 mt-2">{certificates.length} certificates earned • Show off your achievements.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {certificates.map((c, i) => (
                    <Link
                        key={c.id}
                        to={`/certificates/${c.id}`}
                        data-testid={`cert-${c.id}`}
                        className="group relative bg-ink-700 rounded-3xl border border-white/5 overflow-hidden p-6 hover:border-lime/30 transition-all hover:-translate-y-1 fade-up"
                        style={{ animationDelay: `${i * 60}ms` }}
                    >
                        <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full bg-lime/10 blur-2xl group-hover:bg-lime/20 transition-colors" />
                        <div className="relative">
                            <div className="w-12 h-12 rounded-2xl bg-lime/15 border border-lime/30 flex items-center justify-center mb-5">
                                <Award className="w-6 h-6 text-lime" />
                            </div>
                            <div className="text-xs uppercase tracking-widest text-gray-500 font-semibold">Certificate of Completion</div>
                            <h3 className="font-display font-bold text-xl mt-2 leading-tight">{c.courseTitle}</h3>
                            <div className="mt-4 flex items-center gap-2 text-xs text-gray-400">
                                <Calendar className="w-3.5 h-3.5" /> Issued {new Date(c.issuedAt).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                            </div>
                            <div className="mt-2 text-xs text-gray-500">By {c.instructor} • Grade <span className="text-lime font-bold">{c.grade}</span></div>
                            <div className="mt-6 pt-5 border-t border-white/5 flex items-center justify-between">
                                <span className="text-[11px] text-gray-500 font-mono">{c.code}</span>
                                <span className="inline-flex items-center gap-1.5 text-sm font-bold text-lime group-hover:gap-2.5 transition-all">
                                    <Eye className="w-3.5 h-3.5" /> View
                                </span>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </AppLayout>
    );
}
